<template>
  <div class="training-wrap"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="batchList">
      <template v-if="batchList.length">
        <div class="header">
          <span class="label">选择批次：</span>
          <el-select v-model="batchId" size="mini" filterable>
            <el-option v-for="batch in batchList"
                       :key="batch.id"
                       :label="batch.name"
                       :value="batch.id"/>
          </el-select>
        </div>
        <div class="cont">
          <slot v-bind="panelParams"></slot>
        </div>
      </template>
      <template v-else>
        <Hint type="empty">
          <div>暂无批次</div>
        </Hint>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading" type="error">
        <div>{{ errorMsg || '获取批次列表失败' }}</div>
        <el-button type="text" @click="loadData">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import Hint from '../../../../../elements/Hint.vue'
export default {
  name: 'TrainingWrap',
  components: {
    Hint
  },
  props: {
    fetchUrl: {
      type: String,
      default: '/workspace/manager/training/batch/batchDropdown'
    }
  },
  data () {
    return {
      batchId: '',
      batchList: null,
      loading: false,
      errorMsg: ''
    }
  },
  computed: {
    panelParams () {
      return {
        batchId: this.batchId
      }
    }
  },
  watch: {
    batchList (val) {
      if (val && val.length) {
        this.batchId = val[0].id
      }
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      this.$ajax({
        method: 'post',
        url: this.fetchUrl
      }).then(response => {
        if (response.data && response.data.responseCode === 'SUCCESS') {
          this.batchList = response.data.batchList || []
        } else {
          this.errorMsg = (response.data && response.data.message) || '获取批次列表失败'
        }
      }, () => {
        this.errorMsg = '获取批次列表失败'
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.training-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  & > .header {
    padding: 20px 20px 10px;
    font-size: 12px;
  }
  & > .cont {
    flex: 1;
    height: 0;
  }
}
</style>
